"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Consent = Consent;
exports.CopyrightContainer = exports.ConsentContainer = void 0;
exports.FooterLegal = FooterLegal;
exports.LegalMenuContainer = exports.FooterLegalContainer = void 0;
exports.TOS = TOS;
exports.TOSContainer = void 0;
var _react = _interopRequireDefault(require("react"));
var _react2 = require("@linaria/react");
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _menu = _interopRequireDefault(require("../../navigation/other/menu"));
var _menuItem = _interopRequireDefault(require("../../navigation/other/menu/menu-item"));
const FooterLegalContainer = exports.FooterLegalContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "FooterLegalContainer",
  class: "pl-f1mxdf5j"
});
const ConsentContainer = exports.ConsentContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "ConsentContainer",
  class: "pl-cwuurzf"
});
const TOSContainer = exports.TOSContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "TOSContainer",
  class: "pl-tx5cytw"
});
const CopyrightContainer = exports.CopyrightContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "CopyrightContainer",
  class: "pl-c11xda1b"
});
const LegalMenuContainer = exports.LegalMenuContainer = /*#__PURE__*/(0, _react2.styled)("nav")({
  name: "LegalMenuContainer",
  class: "pl-lh4bb02"
});

/**
 * Consent component.
 *
 * @param {Object} props React props
 * @param {string} props.consent Consent Text
 * @param {string} props.consentLink Consent Link Text
 * @returns {React.ReactElement} Consent div
 * @public
 */
function Consent({
  consent,
  consentLink
}) {
  return /*#__PURE__*/_react.default.createElement(ConsentContainer, {
    "data-cy": "consent"
  }, !consentLink && consent, consentLink && /*#__PURE__*/_react.default.createElement("a", {
    href: consentLink
  }, consent));
}
Consent.propTypes = {
  consent: _propTypes.default.node,
  consentLink: _propTypes.default.string
};

/**
 * TOS component.
 *
 * @param {Object} props React props
 * @param {string} props.termsOfService TOS Text
 * @param {string} props.termsOfServiceLink Tos Link
 * @param {string} props.tosTextWithLink Tos text with link
 * @returns {React.ReactElement} TOS div
 * @public
 */
function TOS({
  termsOfService,
  tosTextWithLink,
  termsOfServiceLink
}) {
  return /*#__PURE__*/_react.default.createElement(TOSContainer, {
    "data-cy": "tos"
  }, termsOfService, termsOfServiceLink && tosTextWithLink && /*#__PURE__*/_react.default.createElement("a", {
    href: termsOfServiceLink
  }, tosTextWithLink));
}
TOS.propTypes = {
  termsOfService: _propTypes.default.node,
  termsOfServiceLink: _propTypes.default.string
};

/**
 * FooterLegal component.
 *
 * @param {Object} props React props
 * @param {object} props.menu Legal Menu list
 * @param {string} props.consent Consent Text
 * @param {string} props.consentLink Consent Link Text
 * @param {string} props.copyright Copyright Text
 * @param {string} props.termsOfService TOS Text
 * @param {string} props.termsOfServiceLink Tos Link
 * @returns {React.ReactElement} Footer Legal layout
 * @public
 */
function FooterLegal({
  id,
  menu,
  consent,
  consentLink,
  copyright,
  termsOfService,
  termsOfServiceLink
}) {
  const menuItems = menu?.menuItems;
  return /*#__PURE__*/_react.default.createElement(FooterLegalContainer, {
    id: `id-${id}`,
    "data-cy": "footer-legal"
  }, menuItems?.length && /*#__PURE__*/_react.default.createElement(LegalMenuContainer, {
    "data-cy": "legal-menu"
  }, /*#__PURE__*/_react.default.createElement(_menu.default, null, menuItems?.map(({
    title,
    href,
    ariaLabel
  }, i) => /*#__PURE__*/_react.default.createElement(_menuItem.default, {
    key: i,
    text: title,
    link: href,
    ariaLabel: ariaLabel
  })))), /*#__PURE__*/_react.default.createElement(Consent, {
    consent: consent,
    consentLink: consentLink
  }), /*#__PURE__*/_react.default.createElement(CopyrightContainer, null, copyright), /*#__PURE__*/_react.default.createElement(TOS, {
    termsOfService: termsOfService,
    termsOfServiceLink: termsOfServiceLink
  }));
}
FooterLegal.propTypes = {
  id: _propTypes.default.string,
  menuItems: _propTypes.default.object,
  ...Consent.propTypes,
  ...TOS.propTypes,
  copyright: _propTypes.default.string
};